import { useRecords } from '@/shared/hooks'

export const usePartnersTopLikes = (
  apiBasePath: string,
  enabled: boolean
): number[] => {
  const { records = [] } = useRecords({
    r: enabled ? `${apiBasePath}/top_likes` : '',
    shouldFetch: enabled
  })

  return Array.isArray(records) ? (records as number[]) : []
}
